import type firebase from 'firebase/app';

import type { Structure } from 'src/modules/designStudio/helpers/data/TemplateDesignConfig';

import type { VersionDocument } from './documentTypes';
import { FirestoreEngine } from './firestoreEngine';

class BuildingModel {
  ref?: firebase.firestore.DocumentReference;

  jobId: number;

  engine: FirestoreEngine;

  constructor(jobId: number) {
    this.jobId = jobId;
    this.engine = new FirestoreEngine(jobId);
  }

  async getBuildingModelReference() {
    this.ref = await this.engine.getBuildingModelReference();
    return this.ref;
  }

  async getShare(shareToken: string) {
    return this.engine.getShare(shareToken);
  }

  async getVersionMarkedAsCurrent(userId: number) {
    return this.engine.getVersionMarkedAsCurrent(userId);
  }

  async createVersion(
    authorId: number,
    sessionId: string,
    history: VersionDocument[] | null,
    designConfig: Structure,
    currentIndexInHistory: number | undefined,
  ) {
    return this.engine.createVersion(
      authorId,
      sessionId,
      history,
      designConfig,
      currentIndexInHistory,
    );
  }
}

export { BuildingModel };
